import popUpsFeatures from "./popUpsFeaturesSlice";
export default popUpsFeatures;
